import Glide from '@glidejs/glide';

function GlideInit(el) {
    const width = window.matchMedia('(max-width: 599px)');
    const slideTrackSize = el.querySelector('.glide__track').clientWidth;
    const minSlideSize = 400;
    const slideCount = el.querySelectorAll('.glide__slide');
    const setSlidePerView = () => {
        if (slideTrackSize / minSlideSize > 3) return 3.1;
        if (slideTrackSize / minSlideSize > 2) return 3;
        return 2;
    };

    const config = {
        type: 'slider',
        startAt: 0,
        perView: setSlidePerView(),
        gap: 25,
        rewind: false,
        bound: true,
        dragThreshold: 0,
        breakpoints: {
            1220: {
                perView: setSlidePerView() >= 3 ? 2 : 1.35, // Show a little of the next card
            },
            767: {
                perView: 2,
            },
            599: {
                perView: 1,
            },
        },
    };
    new Glide(el, config).mount();
    if (!width.matches && slideCount.length <= 3) {
        el.classList.add('glide--disabled');
    }
}

export default function sliderContainerInit(elements) {
    elements.forEach(el => {
        GlideInit(el);
    });
}
